import { Component } from "@angular/core"
import { WindowSizeService } from "../../services/window-size.service"
import { CookiesService } from "../../services/cookies.service"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-alert-bar",
    templateUrl: "./alert-bar.component.html",
    styleUrls: ["./alert-bar.component.less"],
})
export class AlertBarComponent {
    public showAlert: boolean = true
    public alertData: any
    public shouldDisplayComponent: boolean
    private readonly cookieKey: string = "showAlert"

    constructor(
        public windowSize: WindowSizeService,
        private cookieService: CookiesService,
        private userService: UserService
    ) {}

    ngOnInit() {
        let alertCookie = this.cookieService.getCookie(this.cookieKey)
        this.alertData = this.userService.alertData
        this.shouldDisplayComponent = this.shouldDisplay()

        if (!this.alertData || (alertCookie && alertCookie.value === "false")) {
            this.showAlert = false
        }
    }

    public close() {
        this.showAlert = false
        this.cookieService.setCookie(
            this.cookieKey,
            "false",
            this.alertData.day_number
        )
    }

    public shouldDisplay(): boolean {
        if (this.alertData && this.alertData.page_regex) {
            return !new RegExp(this.alertData.page_regex).test(
                window.location.pathname
            )
        }

        return false
    }
}
